import { faClass } from '@/constants/icons';
import i18n from '@/i18n';
import { seatsSummary, vehicleCategoryIcon, vehicleTypesMap } from '@modules/logic/vehiclesLogic';

import styles from './VehicleChip.module.scss';

/**
 * VehicleChip — pillola del mezzo assegnato (icona tipologia + targa).
 *
 * L'icona è derivata dalla categoria del mezzo (`vehicle.type`: auto/bus/van/
 * ambulance), non fissa: un'ambulanza non deve mostrare l'icona di un bus.
 * `type` è l'entità "tipologia pulmino" (`vehicle_types`), fonte di verità dei
 * posti — passarla quando serve `showSeats`, altrimenti si ricade sui campi
 * legacy del mezzo.
 *
 * `tone="ghost"` per gli header colorati (vetro bianco, leggibile su qualunque
 * colore azienda), `surface` su sfondo chiaro.
 *
 * Senza `vehicle` non renderizza nulla: il placeholder lo decide il chiamante.
 */
export default function VehicleChip({
  vehicle,
  type = null,
  tone = 'surface',
  showModel = false,
  showSeats = false,
  className = '',
  ...rest
}) {
  if (!vehicle) return null;

  const plate = vehicle.targa || vehicle.nome || vehicle.label || '—';
  const model = vehicle.model || null;
  const categoryLabel = vehicleTypesMap[vehicle.type]?.label;
  const seats = showSeats
    ? seatsSummary(vehicle, type, (k, d) => i18n.t(k, { defaultValue: d }))
    : null;

  const title = [plate, model, type?.name || (categoryLabel && i18n.t(categoryLabel)), seats]
    .filter(Boolean)
    .join(' · ');

  return (
    <span className={`${styles.chip} ${styles[tone]} ${className}`.trim()} title={title} {...rest}>
      <i className={faClass(vehicleCategoryIcon(vehicle.type))} aria-hidden="true" />
      <span className={styles.plate}>{plate}</span>
      {showModel && model && <span className={styles.meta}>({model})</span>}
      {seats && <span className={styles.meta}>{seats}</span>}
    </span>
  );
}
